import * as React from "react";
import {
  CompositeDecorator,
  ContentBlock,
  ContentState,
  EditorState,
} from "draft-js";
import { BaseEmoji } from "emoji-mart";
import { Emoji, getEmojiFromNative } from "../Emoji";
import { findWithRegex, unicodeRegex } from "./utils";

const EditorStateContext = React.createContext<
  [EditorState, React.Dispatch<React.SetStateAction<EditorState>>]
>(undefined as any);

const emojiStrategy = (
  contentBlock: ContentBlock,
  callback: (start: number, end: number) => void
) => {
  findWithRegex(unicodeRegex, contentBlock, callback);
};

const compositeDecorator = new CompositeDecorator([
  {
    strategy: emojiStrategy,
    component: ({
      entityKey,
      contentState,
      decoratedText,
      children,
    }: {
      contentState: ContentState;
      decoratedText: string;
      children: React.ReactNode;
      entityKey?: string;
    }) => {
      let emoji: BaseEmoji | null = null;
      if (entityKey !== undefined) {
        const { emoji: emojiSupplied } = contentState
          .getEntity(entityKey)
          .getData();
        emoji = emojiSupplied;
      }

      if (entityKey === undefined)
        emoji = getEmojiFromNative(decoratedText) ?? null;

      return (
        <>
          {emoji === null ? (
            children
          ) : (
            <span className="chat-input-emoji">
              <Emoji emoji={emoji.colons} size={16} />
              <span className="hidden">{children}</span>
            </span>
          )}
        </>
      );
    },
  },
]);

export const EditorStateProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const state = React.useState(EditorState.createEmpty(compositeDecorator));
  return (
    <EditorStateContext.Provider value={state}>
      {children}
    </EditorStateContext.Provider>
  );
};

export const useEditorState = () => {
  return React.useContext(EditorStateContext);
};
